import "./Button.scss";

export default function Button(props: { content: string; classtitle: string }) {
  return <button className={props.classtitle}>{props.content}</button>;
}
